/* eslint-disable */
/*  value_equals.js
    
    The MIT License (MIT)
    
    Copyright (c) 2013-2017, Reactive Sets
    
    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:
    
    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.
    
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

export default function equals(a, b, enforce_properties_order, cyclic, verbose) {
  let startComparison = a === b       // strick equality should be enough unless zero
    && a !== 0         // because 0 === -0, requires test by _equals()
    || _equals(a, b);  // handles not strictly equal or zero values
  if (verbose && !startComparison) console.log('START OBJECTS', a, b);
  return startComparison;

  function _equals(a, b) {
    // a and b have already failed test for strict equality or are zero

    var s, l, p, x, y;

    // They should have the same toString() signature
    if ((s = toString.call(a)) !== toString.call(b)) {
      if (verbose) console.log('SIGNATURE', toString.call(a), toString.call(b));
      return false;
    }

    switch (s) {
      default: // Boolean, Date, String
        if (verbose && a.valueOf() !== b.valueOf()) console.log('BOOLEAN, DATE, STRING', a.valueOf(), b.valueOf());
        return a.valueOf() === b.valueOf();

      case '[object Number]':
        // Converts Number instances into primitive values
        // This is required also for NaN test bellow
        a = +a;
        b = +b;
        let numberComparison = a ?         // a is Non-zero and Non-NaN
          a === b
          :                // a is 0, -0 or NaN
          a === a ?      // a is 0 or -O
            1 / a === 1 / b    // 1/0 !== 1/-0 because Infinity !== -Infinity
            : b !== b        // NaN, the only Number not equal to itself!
          ;
        if (verbose && !numberComparison) console.log('NUMBER', a, b);
        return numberComparison;
        // [object Number]

      case '[object RegExp]':
        let regexComparison = a.source == b.source
          && a.global == b.global
          && a.ignoreCase == b.ignoreCase
          && a.multiline == b.multiline
          && a.lastIndex == b.lastIndex
          ;
        if (verbose && !regexComparison) console.log('REGEX', a, b);
        return regexComparison;
        // [object RegExp]

      case '[object Function]':
        if (verbose) console.log('FUNCTION, always false', a, b);
        return false; // functions should be strictly equal because of closure context
        // [object Function]

      case '[object Array]':
        if (cyclic && (x = reference_equals(a, b)) !== null) return x; // intentionally duplicated bellow for [object Object]

        let arraySizeComparison = (l = a.length) != b.length;

        if (verbose && arraySizeComparison) console.log('ARRAY NOT SAME SIZE', a, b);
        if (arraySizeComparison) return false;
        // Both have as many elements

        while (l--) {

          let arrayComparison = (x = a[l]) === (y = b[l]) && x !== 0 || _equals(x, y);
          if (arrayComparison) continue;

          if (verbose) console.log('ARRAY DIFFERENT', a, b);
          return false;
        }

        return true;
        // [object Array]

      case '[object Object]':
        if (cyclic && (x = reference_equals(a, b)) !== null) return x; // intentionally duplicated from above for [object Array]

        l = 0; // counter of own properties

        if (enforce_properties_order) {
          var properties = [];

          for (p in a) {
            if (a.hasOwnProperty(p)) {
              properties.push(p);

              if ((x = a[p]) === (y = b[p]) && x !== 0 || _equals(x, y)) continue;

              return false;
            }
          }

          // Check if 'b' has as the same properties as 'a' in the same order
          for (p in b)
            if (b.hasOwnProperty(p) && properties[l++] != p)
              return false;
        } else {
          for (p in a) {
            if (a.hasOwnProperty(p)) {
              ++l;
              let objectComparison = (x = a[p]) === (y = b[p]) && x !== 0 || _equals(x, y);
              if (objectComparison) continue;
              if (verbose) console.log('OBJECT PROPERTIES DIFFERENT', a, b, 'AT PROPERTY', a[p], b[p]);
              return false;
            }
          }

          // Check if 'b' has as not more own properties than 'a'
          for (p in b)
            if (b.hasOwnProperty(p) && --l < 0) {
              if (verbose) console.log('OBJECT DIFFERENT AMOUNT OF PROPERTIES', a, b);
              return false;
            }
        }

        return true;
      // [object Object]
    } // switch toString.call( a )
  } // _equals()

  /* -----------------------------------------------------------------------------------------
    reference_equals( a, b )
    
    Helper function to compare object references on cyclic objects or arrays.
    
    Returns:
      - null if a or b is not part of a cycle, adding them to object_references array
      - true: same cycle found for a and b
      - false: different cycle found for a and b
    
    On the first call of a specific invocation of equal(), replaces self with inner function
    holding object_references array object in closure context.
    
    This allows to create a context only if and when an invocation of equal() compares
    objects or arrays.
  */
  function reference_equals(a, b) {
    var object_references = [];

    return (reference_equals = _reference_equals)(a, b);

    function _reference_equals(a, b) {
      var l = object_references.length;

      while (l--)
        if (object_references[l--] === b)
          return object_references[l] === a;

      object_references.push(a, b);

      return null;
    } // _reference_equals()
  } // reference_equals()
} // equals()